import { ChevronDown, LogOut } from 'lucide-react';

import { UserAvatar } from '@/components/shared/user-avatar';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth, useCurrentUser } from '@/features/auth/auth-context';
import { displayNameOf } from '@/features/auth/display-name';
import { roleLabels } from '@/features/auth/types';

export function UserMenu() {
  const { profile } = useCurrentUser();
  const { signOut } = useAuth();
  const displayName = displayNameOf(profile);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex items-center gap-2 rounded-md py-1 pr-1.5 pl-1 text-left transition-colors hover:bg-surface-sunken focus-visible:outline-2 focus-visible:outline-ring"
        aria-label={`Menú de usuario: ${displayName}`}
      >
        <UserAvatar
          name={profile.full_name}
          email={profile.email}
          avatarUrl={profile.avatar_url}
          size="sm"
        />
        <span className="hidden max-w-44 min-w-0 flex-col md:flex">
          <span className="truncate text-sm leading-tight font-medium text-foreground">
            {displayName}
          </span>
          <span className="truncate text-[0.6875rem] leading-tight text-muted-foreground">
            {roleLabels[profile.role]}
          </span>
        </span>
        <ChevronDown className="size-4 text-muted-foreground" aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64">
        <DropdownMenuLabel>
          <p className="truncate font-medium text-foreground">{displayName}</p>
          <p className="truncate text-xs text-muted-foreground">{profile.email}</p>
          <Badge tone="brand" className="mt-2">
            {roleLabels[profile.role]}
          </Badge>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem tone="danger" onSelect={() => void signOut()}>
          <LogOut aria-hidden="true" />
          Cerrar sesión
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
